import React from "react";
import { formatPhoneNumber } from "react-phone-number-input";
import _authIcon from "../../../componets/json/authIcon";
import {
  Row,
  Col,
  Form,
  Button,
  Alert,
  Card,
  Image,
  Spinner,
} from "react-bootstrap";
import AddAddress from "../../user/componets/AddAdress";
import { VscTypeHierarchySub } from "react-icons/vsc";
import RenderAddress from "../../user/componets/_renderAddress";
import _selectVendor from "../../user/componets/_selectVendor";
import _renderVendor from "../../user/componets/_renderVendor";
import BrtxSelect from "../../../componets/BrtxSelect";
import _selectDevice from "../../user/componets/_selectDevice";
import _renderDevice from "../../user/componets/_renderDevice";
import apiEndPoints from "../../../componets/json/apiEndPoints.json";
import dpd from "../../../assets/img/career/dpd.png";
import mobile from "../../../componets/json/mobile.json";

class vodafone extends React.Component {
  state = {
    invoice: {
      open: false,
      address: {
        type: "F",
        ico: "25788001",
        zipcode: "15500",
        city: {
          label: "Praha",
          value: "Praha",
        },
        street: {
          label: "náměstí Junkových",
          value: "náměstí Junkových",
        },
        region: {
          label: "Hlavní město Praha",
          value: "Hlavní město Praha",
        },
        houseno: {
          label: "2808",
          value: "2808",
        },
        CntctName: "Vodafone Czech Republic a.s.",
        desc: "Vodafone",
        country: {
          label: "Česká republika",
          value: "CZ",
          countrynum: "203",
        },
        default: false,
      },
    },
    delivery: {
      open: false,
      address: null,
    },
    pickup: {
      open: false,
      address: null,
    },
    vendor: {
      open: false,
      vendor: null,
    },
    device: {
      open: false,
      device: null,
    },
    request: {
      reqId: null,
      shipNo: null,
      ref: null,
      desc: null,
    },
    loader: false,
    onValid: false,
    onValidType: "",
  };

  setVdfAddr = () => {
    this.setState({
      invoice: {
        ...this.state.invoice,
        address: {
          type: "F",
          ico: "25788001",
          zipcode: "15500",
          city: {
            label: "Praha",
            value: "Praha",
          },
          street: {
            label: "náměstí Junkových",
            value: "náměstí Junkových",
          },
          region: {
            label: "Hlavní město Praha",
            value: "Hlavní město Praha",
          },
          houseno: {
            label: "2808",
            value: "2808",
          },
          CntctName: "Vodafone Czech Republic a.s.",
          desc: "Vodafone",
          country: {
            label: "Česká republika",
            value: "CZ",
            countrynum: "203",
          },
          default: false,
        },
      },
    });
  };

  setVendor = (e) => {
    this.setState({ vendor: { ...this.state.vendor, open: false, vendor: e } });
  };
  setDevice = (e) => {
    this.setState({ device: { ...this.state.device, open: false, device: e } });
  };

  save = async (x) => {
    //kontroly před odesláním
    if (
      !this.state.delivery.address.mobil &&
      !this.state.delivery.address.email
    ) {
      this.setState({ onValid: true, onValidType: "D" });
      return;
    } else {
      if (
        !this.state.pickup.address.mobil &&
        !this.state.pickup.address.email
      ) {
        this.setState({ onValid: true, onValidType: "P" });
        return;
      } else {
        if (!this.state.vendor.vendor) {
          this.setState({ vendor: { ...this.state.vendor, open: true } });
        } else {
          if (!this.state.device.device) {
            this.setState({ device: { ...this.state.device, open: true } });
          } else {
            if (!this.state.device.info.repairType) {
              this.setState({
                alert: { detail: "Není vyplněno pole druh opravy" },
              });
              window.scrollTo(0, 0);
            } else {
              if (!this.state.device.info.IMEI && !this.state.device.info.SN) {
                this.setState({
                  alert: { detail: "Musí být doplněno IMEI nebo SN zařízení" },
                });
                window.scrollTo(0, 0);
              } else {
                this.setState({ loader: true });
                const _res = await this.props._api({
                  ...this.props,
                  method: apiEndPoints.britex.service.ServiceRequest_v2.method,
                  endpoint:
                    apiEndPoints.britex.service.ServiceRequest_v2.endPoint,
                  data: JSON.stringify(this.state),
                  param: "",
                });
                this.setState({ loader: false });
                if (_res.status == 200) {
                  this.setState({ request: _res.data });
                  window.scrollTo(0, 0);
                }

                if (_res.status != 200) {
                  this.setState({ alert: _res.data });
                  window.scrollTo(0, 0);
                }
              }
            }
          }
        }
      }
    }
  };

  componentDidMount() {
    this.props.setHeaderPage({
      Icon: _authIcon("SiVodafone", "c-placeholder c-red"),
      Title: "Vodafone požadavky",
      SubTitle: "",
    });
  }

  render() {
    const { Bs } = this.props;
    if (process.env.REACT_APP_VDF_KEY != localStorage.getItem("vdf_key"))
      this.props.setNavigate("/");
    if (this.state.request.reqId) {
      return (
        <>
          <Bs alert variant="success">
            {"Požadavek " +
              this.state.request.reqId +
              " byl úspěšně odeslán. Zákazník byl informován. Vodafone aftersale také."}
          </Bs>
          <Bs card>
            <Bs cardbody>
              <Bs row>
                <Bs
                  col
                  className="d-flex align-items-center justify-content-between"
                >
                  <Bs image style={{ width: "60px" }} src={dpd} />
                  <strong>dpd</strong>
                  <strong>{this.state.request.shipNo}</strong>
                  <small>{this.state.request.desc}</small>
                </Bs>
              </Bs>
            </Bs>
          </Bs>
        </>
      );
    } else
      return (
        <>
          {this.state.alert && (
            <Bs alert variant="danger">
              {this.state.alert?.detail}
            </Bs>
          )}

          {this.state.onValid && (
            <Bs
              modal
              show={this.state.onValid}
              onHide={() => this.setState({ onValid: false })}
              centered
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              backdrop="static"
            >
              <Bs modalheader>Doplňte důležité údaje</Bs>
              <Bs alert variant="danger">
                Email nebo mobil musí být pro{" "}
                {this.state.onValidType == "D" ? "dodací" : "svozovou"} adresu
                vyplněn!
              </Bs>
              <Bs modalbody>
                <Bs row className="mb-2">
                  <Bs
                    formcontrol
                    value={
                      this.state.onValidType == "D"
                        ? this.state.delivery.address?.email
                        : this.state.pickup.address?.email
                    }
                    onChange={(e) => {
                      this.state.onValidType == "D"
                        ? this.setState({
                            delivery: {
                              ...this.state.delivery,
                              address: {
                                ...this.state.delivery.address,
                                email: e.target.value,
                              },
                            },
                          })
                        : this.setState({
                            pickup: {
                              ...this.state.pickup,
                              address: {
                                ...this.state.pickup.address,
                                email: e.target.value,
                              },
                            },
                          });
                    }}
                  ></Bs>
                  <Bs formtext>Email</Bs>
                </Bs>
                <Bs row className="mb-2">
                  <Bs
                    brtxselect
                    options={mobile}
                    placeholder="+420"
                    value={
                      this.state.onValidType == "D"
                        ? this.state.delivery.address?.pre_mobil
                        : this.state.pickup.address?.pre_mobil
                    }
                    onChange={(e) => {
                      this.state.onValidType == "D"
                        ? this.setState({
                            delivery: {
                              ...this.state.delivery,
                              address: {
                                ...this.state.delivery.address,
                                pre_mobil: e,
                              },
                            },
                          })
                        : this.setState({
                            pickup: {
                              ...this.state.pickup,
                              address: {
                                ...this.state.pickup.address,
                                pre_mobil: e,
                              },
                            },
                          });
                    }}
                  ></Bs>
                  <Bs FormText>Předvolba</Bs>
                </Bs>
                <Bs row className="mb-4">
                  <Bs
                    brtxcustom
                    mask="999 999 999"
                    value={
                      this.state.onValidType == "D"
                        ? this.state.delivery.address?.mobil
                        : this.state.pickup.address?.mobil
                    }
                    onChange={(e) => {
                      this.state.onValidType == "D"
                        ? this.setState({
                            delivery: {
                              ...this.state.delivery,
                              address: {
                                ...this.state.delivery.address,
                                mobil: e.target.value,
                              },
                            },
                          })
                        : this.setState({
                            pickup: {
                              ...this.state.pickup,
                              address: {
                                ...this.state.pickup.address,
                                mobil: e.target.value,
                              },
                            },
                          });
                    }}
                  ></Bs>
                  <Bs formtext className="mb-2">
                    Mobil
                  </Bs>
                </Bs>
                <Bs row className="mt-4">
                  <Bs col xs={12} className="d-flex justify-content-end">
                    <Bs
                      button
                      size="sm"
                      variant="success"
                      onClick={() => {
                        this.setState({ onValid: false, onValidType: "" });
                      }}
                    >
                      Aktualizovat
                    </Bs>
                  </Bs>
                </Bs>
              </Bs>
            </Bs>
          )}

          <AddAddress
            {...this.props}
            open={this.state.invoice.open}
            change={(e) => {
              this.setState({ invoice: { open: false, address: e } });
            }}
            onHide={() => this.setState({ invoice: { open: false } })}
            addresstype="F"
            {...this.props}
          />
          <AddAddress
            {...this.props}
            open={this.state.pickup.open}
            change={(e) => {
              this.setState({ pickup: { open: false, address: e } });
            }}
            onHide={() => this.setState({ pickup: { open: false } })}
            addresstype="D"
            {...this.props}
          />
          <AddAddress
            {...this.props}
            open={this.state.delivery.open}
            change={(e) => {
              this.setState({ delivery: { open: false, address: e } });
            }}
            onHide={() => this.setState({ delivery: { open: false } })}
            addresstype="P"
            {...this.props}
          />
          <_selectVendor
            select={this.setVendor}
            {...this.state.vendor}
            {...this.props}
            onHide={() =>
              this.setState({ vendor: { ...this.state.vendor, open: false } })
            }
          />
          {this.state.vendor.vendor && (
            <_selectDevice
              select={this.setDevice}
              vendor={this.state.vendor.vendor}
              {...this.state.device}
              {...this.props}
              onHide={() =>
                this.setState({ device: { ...this.state.device, open: false } })
              }
            />
          )}

          <Row>
            <Col xs={12} className="mb-2">
              <strong className="mb-2">Fakturační adresa</strong>
            </Col>
            {!this.state.invoice.address && (
              <>
                <Col xs={12}>
                  <Button
                    variant="secondary"
                    size="sm"
                    className="me-2"
                    onClick={this.setVdfAddr}
                  >
                    Přidat adresu Vodafone
                  </Button>
                  <Button
                    variant="secondary"
                    size="sm"
                    onClick={() =>
                      this.setState({
                        invoice: { ...this.state.invoice, open: true },
                      })
                    }
                  >
                    Přidat vlastní adresu
                  </Button>
                </Col>
              </>
            )}
            {this.state.invoice.address && (
              <>
                <Col xs={12}>
                  <hr />
                </Col>
                <Col xs={12} className="mt-2 mb-4">
                  <RenderAddress
                    e={this.state.invoice.address}
                    idx={0}
                    remove={() =>
                      this.setState({
                        invoice: { ...this.state.invoice, address: null },
                      })
                    }
                  />
                </Col>
                <Col xs={12} className="mb-2">
                  <strong className="mb-2">Dodací adresa</strong>
                </Col>

                {!this.state.delivery.address && (
                  <Col xs={12}>
                    <Button
                      variant="secondary"
                      size="sm"
                      className="me-2"
                      onClick={() =>
                        this.setState({
                          delivery: {
                            ...this.state.delivery,
                            address: this.state.invoice.address,
                          },
                        })
                      }
                    >
                      Stejná jako fakturační
                    </Button>
                    <Button
                      variant="secondary"
                      disabled
                      data-tip="Momentálně nedostupné"
                      size="sm"
                      className="me-2"
                    >
                      Vybrat prodejnu Vodafone
                    </Button>
                    <Button
                      variant="secondary"
                      size="sm"
                      onClick={() =>
                        this.setState({
                          delivery: { ...this.state.delivery, open: true },
                        })
                      }
                    >
                      Přidat vlastní adresu
                    </Button>
                  </Col>
                )}
                {this.state.delivery.address && (
                  <>
                    <Col xs={12}>
                      <hr />
                    </Col>
                    <Col xs={12} className="mt-2 mb-2">
                      <RenderAddress
                      {...this.props}
                        e={this.state.delivery.address}
                        idx={0}
                        remove={() =>
                          this.setState({
                            delivery: { ...this.state.delivery, address: null },
                          })
                        }
                      />
                    </Col>
                    <Col xs={12} className="mb-2">
                      <strong className="mb-2">Adresa pro svoz</strong>
                    </Col>
                    {!this.state.pickup.address && (
                      <Col xs={12}>
                        <Button
                          variant="secondary"
                          size="sm"
                          className="me-2"
                          onClick={() =>
                            this.setState({
                              pickup: {
                                ...this.state.pickup,
                                address: this.state.invoice.address,
                              },
                            })
                          }
                        >
                          Stejná jako fakturační
                        </Button>
                        <Button
                          variant="secondary"
                          size="sm"
                          className="me-2"
                          onClick={() =>
                            this.setState({
                              pickup: {
                                ...this.state.pickup,
                                address: this.state.delivery.address,
                              },
                            })
                          }
                        >
                          Stejná jako dodací
                        </Button>
                        <Button
                          variant="secondary"
                          size="sm"
                          disabled
                          data-tip="Momentálně nedostupné"
                          className="me-2"
                        >
                          Vybrat prodejnu Vodafone
                        </Button>
                        <Button
                          variant="secondary"
                          size="sm"
                          onClick={() =>
                            this.setState({
                              pickup: { ...this.state.pickup, open: true },
                            })
                          }
                        >
                          Přidat vlastní adresu
                        </Button>
                      </Col>
                    )}
                    {this.state.pickup.address && (
                      <>
                        <Col xs={12}>
                          <hr />
                        </Col>
                        <Col xs={12} className="mt-2 mb-2">
                          <RenderAddress
                            {...this.props}
                            e={this.state.pickup.address}
                            idx={0}
                            remove={() =>
                              this.setState({
                                pickup: { ...this.state.pickup, address: null },
                              })
                            }
                          />
                        </Col>
                        <Row>
                          <Col xs={12} md={6} lg={4} className="mb-2">
                            <Row>
                              <strong className="mb-2">Výrobce</strong>
                            </Row>
                            {!this.state.vendor.vendor && (
                              <Row>
                                <Col>
                                  <Button
                                    variant="secondary"
                                    size="sm"
                                    onClick={() =>
                                      this.setState({
                                        vendor: {
                                          ...this.state.vendor,
                                          open: true,
                                        },
                                      })
                                    }
                                  >
                                    Vybrat
                                  </Button>
                                </Col>
                              </Row>
                            )}
                            {this.state.vendor.vendor && (
                              <_renderVendor e={this.state.vendor.vendor} deleteItm={() => this.setState({vendor: {...this.state.vendor,vendor: null}})} />
                            )}
                          </Col>
                          <Col xs={4} md={6} lg={4} className="mb-2">
                            <Row>
                              <strong className="mb-2">Typ přístroje</strong>
                            </Row>
                            {this.state.device.device && (
                              <_renderDevice e={this.state.device.device} deleteItm={() => this.setState({device: {...this.state.device,device: null}})} />
                            )}
                            {!this.state.device.device && (
                              <Row>
                                <Col>
                                  <Button
                                    variant="secondary"
                                    size="sm"
                                    disabled={!this.state.vendor.vendor}
                                    onClick={() =>
                                      this.setState({
                                        device: {
                                          ...this.state.device,
                                          open: true,
                                        },
                                      })
                                    }
                                  >
                                    Vybrat
                                  </Button>
                                </Col>
                              </Row>
                            )}
                          </Col>
                          <Col xs={4} md={6} lg={4} className="mb-2">
                            <Row>
                              <strong className="mb-2">Druh opravy</strong>
                            </Row>
                            <Row>
                              <BrtxSelect
                                options={[
                                  {
                                    value: 1,
                                    label: "Záruční",
                                  },
                                  {
                                    value: 2,
                                    label: "Nezáruční",
                                  },
                                ]}
                                placeholder="Vyber druh opravy"
                                value={this.state.device.info?.repairType}
                                onChange={(e) =>
                                  this.setState({
                                    device: {
                                      ...this.state.device,
                                      info: {
                                        ...this.state.device.info,
                                        repairType: e,
                                      },
                                    },
                                  })
                                }
                              />
                            </Row>
                          </Col>
                        </Row>
                        <Row className="mt-2 mb-2">
                          <Col xs={6}>
                            <Row>
                              <strong className="mb-2">IMEI</strong>
                            </Row>
                            <Form.Control
                              value={this.state.device.info?.IMEI}
                              onChange={(e) =>
                                this.setState({
                                  device: {
                                    ...this.state.device,
                                    info: {
                                      ...this.state.device.info,
                                      IMEI: e.target.value,
                                    },
                                  },
                                })
                              }
                            />
                          </Col>
                          <Col xs={6}>
                            <Row>
                              <strong className="mb-2">SN</strong>
                            </Row>
                            <Form.Control
                              value={this.state.device.info?.SN}
                              onChange={(e) =>
                                this.setState({
                                  device: {
                                    ...this.state.device,
                                    info: {
                                      ...this.state.device.info,
                                      SN: e.target.value,
                                    },
                                  },
                                })
                              }
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 mb-2">
                          <Row>
                            <strong className="mb-2">Závada</strong>
                          </Row>
                          <Form.Control
                            as="textarea"
                            value={this.state.device.info?.defect}
                            rows={6}
                            onChange={(e) =>
                              this.setState({
                                device: {
                                  ...this.state.device,
                                  info: {
                                    ...this.state.device.info,
                                    defect: e.target.value,
                                  },
                                },
                              })
                            }
                          />
                        </Row>
                        {this.state.device.info?.defect && (
                          <Row className="mb-4">
                            {!this.state.loader && (
                              <Col className="d-flex justify-content-end">
                                <Button
                                  variant="secondary"
                                  size="sm"
                                  className="me-2"
                                  onClick={() => this.save(0)}
                                >
                                  Vytvořit bez svozu
                                </Button>
                                <Button
                                  variant="success"
                                  size="sm"
                                  onClick={() => this.save(1)}
                                >
                                  Vytvořit se svozem
                                </Button>
                              </Col>
                            )}
                            {this.state.loader && (
                              <Spinner animation="border" role="status" />
                            )}
                          </Row>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </Row>
        </>
      );
  }
}

export default vodafone;
